import {Wordlist} from "@game/wordlist";
import {ILocation} from "@game/game";
import {Letter} from "@game/map/letter";
import {Vector2} from "@utility/vector2";
import {Hand} from "@game/player/hand";
import {Region} from "@game/map/region";
import {Player} from "@game/player/player";
import {UserPlayer} from "@game/player/userPlayer";

interface IWordEnd extends ILocation {
    position: Vector2
}
interface IWord {
    from: IWordEnd
    to: IWordEnd
    letters: Letter[]
}

export class Word {
    private _score?: number

    constructor(private props: IWord) {
    }
    
    get from() {
        return this.props.from;
    }

    get letters() {
        return this.props.letters;
    }

    get score() {
        return this._score;
    }

    get to() {
        return this.props.to;
    }

    countPlacedLetters(hand: Hand) {
        return this.props.letters.filter(letter => hand.placed.includes(letter)).length;
    }

    getWordString() {
        return this.props.letters.map(letter => letter.letter).join("");
    }

    updateScore(score: number) {
        this._score = score;
    }
}